<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="introduction">
<h1>Introduction</h1>
<p>I moved to Ireland on November 24<sup>th</sup>, 2008, a middle-aged man in search of something. Since then I have often been asked, “What brings you to Ireland?” My usual answer would be, “Well, it’s all because of Daisy.” Of course life is never so simple. However, my time in Ireland has given me the opportunity to fully consider my route to Ireland and more importantly, why I stay.</p>
<p>Inspiration comes in many guises. Last summer I watched my very good friend, John Crotty, build a kennel for my two greyhounds overlooking the field. I saw a man different from myself and yet similar to myself. I saw a man create something within a few short days that could last for years. I asked myself what I had built. Nothing. I decided there and then that it was time to create and complete something myself, hence this piece of work. My experiences in Ireland have widened and changed my perspectives of life. In telling the tale I hope those, who know me well, will understand why I needed to leave one world for another in search of a dream and why I stayed because of the truth.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch005.vue?a31bc6da